// extracted by mini-css-extract-plugin
export var categories__category = "Categories-module--categories__category--8fd17";
export var categories__container = "Categories-module--categories__container--76e5e";
export var categories__content = "Categories-module--categories__content--b6cce";